export const SET_LANG = 'SET_LANG';
export const SET_LANG_ROUTE = 'SET_LANG_ROUTE';
export const SET_LANG_MAP = 'SET_LANG_MAP';